import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyGetCollections = async () => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `{
          collections(first:100) {
            edges {
              node {
                id
                title
                image {
                  src
                }
                categories: metafield(key:"patch_categories", namespace:"custom") {
                  value
                }
              }
            }
          }
        }`,
      },
    });
    if (response.data.data.collections) {
      const { collections } = response.data.data;
      return collections.edges.map((e) => e.node).filter((e) => !!e.categories);
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetCollections;
